import { Component } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastmessageService } from 'src/app/toastmessage.service';
import { StudentCounsellingReportService } from '../student-counselling-report.service';
import { map, startWith } from 'rxjs';
import { StudentCounsellingReportDialogComponent } from '../student-counselling-report-dialog/student-counselling-report-dialog.component';
import { NgDialogAnimationService } from 'ng-dialog-animation';
import { ExcelExportParams, GridReadyEvent } from 'ag-grid-community';
import { GridApi, ColDef } from 'ag-grid-community';
import { StudentreportDialogComponent } from '../studentreport-dialog/studentreport-dialog.component';

@Component({
  selector: 'app-student-counselling-report',
  templateUrl: './student-counselling-report.component.html',
  styleUrls: ['./student-counselling-report.component.scss']
})
export class StudentCounsellingReportComponent {
  columnDefs = [
    { headerName: 'S.No', field: 'sNo', sortable: true, filter: true, width: 100 },
    { headerName: 'Admission No', field: 'admNo', sortable: true, filter: true },
    { headerName: 'Name', field: 'name', sortable: true, filter: true },
    { headerName: 'Campus', field: 'campusName', sortable: true, filter: true },
    { headerName: 'Counsellor', field: 'counsellorName', sortable: true, filter: true },
    {
      headerName: 'Date of Visit',
      field: 'dateOfVisit',
      valueFormatter: (params: any) =>
        new Date(params.value).toLocaleDateString(),
      sortable: true,
      filter: true
    },
    {
      headerName: 'Status',
      field: 'status',
      cellRenderer: (params: any) => (params.value ? '✔️' : '❌'),
      sortable: true,
      filter: true, width: 140
    },
    // { headerName: 'Category', field: 'categoryName', sortable: true, filter: true }
  ];


  defaultColDef = {
    resizable: true,
    filter: true,
    sortable: true
  };

  selectedParams: any = {};
  counsellingReport: any
  Academicyearlist: any[] = [];
  AcademicOptions: any;
  rowData: any[] = [];
  private gridApi!: GridApi<any>;
  quickFilter: string = ''
  constructor(private verification: StudentCounsellingReportService, private spinner: NgxSpinnerService, private fb: FormBuilder, private toast: ToastmessageService, private route: ActivatedRoute, private dialog: NgDialogAnimationService) { }
  ngOnInit(): void {
    // this.adapter.setLocale('en-GB');

    this.openfilterdialog()
    this.getAcademicyear()

  }
  defaultExcelExportParams: ExcelExportParams = {
    exportAsExcelTable: true,
  };
  getAcademicyear() {

  }
  onAcademicYearChange(selectedYear: string) {
    console.log("Selected year:", selectedYear);
    // this.getCampusByYear(selectedYear);
  }
  openfilterdialog() {
    const dialogRef = this.dialog.open(StudentCounsellingReportDialogComponent, {
      width: '40%',
      height: '100%',
      panelClass: ['custom-dialog-panel'],
      position: { right: '0px' },
      animation: { to: 'left' },
      maxWidth: '100%',
      disableClose: false,
      hasBackdrop: true,
      data: this.selectedParams
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result?.params) {
        this.selectedParams = result.params;
        this.spinner.show()
        this.verification.getreport(result.params).subscribe({
          next: (res: any) => {
            if(!res){
              this.spinner.hide()
              return;
            }
            this.rowData = Array.isArray(res) && res.length > 0 ? res : [];

            // Base columns
            this.columnDefs = [
              { headerName: 'S.No', field: 'sNo', sortable: true, filter: true, width: 100 },
              { headerName: 'Admission No', field: 'admNo', sortable: true, filter: true },
              { headerName: 'Name', field: 'name', sortable: true, filter: true },
              { headerName: 'Campus', field: 'campusName', sortable: true, filter: true },
              { headerName: 'Counsellor', field: 'counsellorName', sortable: true, filter: true },
              {
                headerName: 'Date of Visit',
                field: 'dateOfVisit',
                valueFormatter: (params: any) =>
                  new Date(params.value).toLocaleDateString(),
                sortable: true,
                filter: true
              },
              {
                headerName: 'Status',
                field: 'status',
                cellRenderer: (params: any) => (params.value ? '✔️' : '❌'),
                sortable: true,
                filter: true,
                width: 140
              }
            ];


            const hasCategory = res.some((e: any) => !!e.category);
            console.log("hasCategory",hasCategory)
            if (hasCategory) {
              this.columnDefs.push({
                headerName: 'Category',
                field: 'category',
                sortable: true,
                filter: true
              });
            }

            this.spinner.hide();
          },
          error: (err) => {
            if (err.status === 204) {
              this.rowData = [];
              this.spinner.hide();
            } else {
              console.error('API Error:', err);
              this.spinner.hide();
            }
            this.spinner.hide();
          }
        });
      }
    });

  }

  onBtExport() {
    this.gridApi.exportDataAsExcel({
      fileName: 'StudentCounselling',
      sheetName: 'CounsellingReport'
    });
    alert("Execl Report genarated Please check the Download List")
  }

  onGridReady(params: any) {
    this.gridApi = params.api;
    // this.gridColumnApi = params.columnApi;
    this.gridApi.closeToolPanel();
  }

  onQuickFilterChanged(event: any) {
    this.quickFilter = event.target.value;
  }


}
